import React, { useState, useMemo, useEffect, useContext, useCallback } from 'react'
import CustomBreadcrumb from '../../common/CustomBreadcrumb'
import { BreadCrum } from '../../common'
import { useNavigate, useLocation } from 'react-router-dom';
import { Select, DatePicker, TimePicker, message, Spin, Popover } from 'antd';
import axios from 'axios';
import { CalanderIcon, ChevronIcon, ExportResult, InfoIcon, TimeIcon, TimezoneSelectedIcon, Trash } from '../../assets/icon';
import dayjs from 'dayjs';
import moment from 'moment';
import 'react-big-calendar/lib/css/react-big-calendar.css';
import { Calendar, momentLocalizer } from 'react-big-calendar';
import CsvUploadDragger from '../Dragger/CsvUploadDragger';
import { useFormik } from 'formik';
import * as Yup from 'yup';
import { useDispatch, useSelector } from 'react-redux';
import { createAiCampaignAction, createAiCampaignHandler } from '../../redux/action/createAiCampaignSlice';
import { updateAiCampaignHandler, updateAiCampaignAction } from '../../redux/action/updateAiCampaignSlice';
import { getAiCampaignDetailsHandler, getAiCampaignDetailsAction } from '../../redux/action/getAiCampaignDetailsSlice';
import { productListDropdownHandler } from '../../redux/action/productListDropdownAPI';
import { downloadAiCampaignSampleCsvAction, downloadAiCampaignSampleCsvHandler } from '../../redux/action/downloadAiCampaignSampleCsvSlice';
import Loader from '../Loder/loader';
import CampaignModal from "../../common/CampaignModal";
import { ThemeContext } from '../../common/themeContext';
import { API_URL } from '../../services/http';
import { getItem } from '../../common/localStorage';
import infoicon from "../../assets/infoicon.svg";

const localizer = momentLocalizer(moment);

const PREFERRED_OUTREACH_OPTIONS = [
    { key: '9-10', label: '9:00 am - 10:00 am CST', startTime: '09:00:00', endTime: '10:00:00', timezone: 'CST' },
    { key: '11-12', label: '11:00 am - 12:00 pm CST', startTime: '11:00:00', endTime: '12:00:00', timezone: 'CST' },
    { key: '2-3', label: '2:00 pm - 3:00 pm CST', startTime: '14:00:00', endTime: '15:00:00', timezone: 'CST' },
];

const TIMEZONE_OPTIONS = [
    { value: 'PST', label: 'PST' },
    { value: 'EST', label: 'EST' },
    { value: 'CST', label: 'CST' },
    { value: 'MST', label: 'MST' },
];

const PRODUCT_PAGE_SIZE = 10;

const parseTimeToDayjs = (timeStr) => {
    if (!timeStr) return null;
    return dayjs(`1970-01-01 ${timeStr}`);
};

/** Combine campaign date + TimePicker value into one dayjs (time-of-day from `timeVal`). */
const combineCampaignDateTime = (dateVal, timeVal) => {
    if (!dateVal || !timeVal) return null;
    const d = dayjs(dateVal);
    const t = dayjs(timeVal);
    if (!d.isValid() || !t.isValid()) return null;
    return d.hour(t.hour()).minute(t.minute()).second(t.second()).millisecond(0);
};

const buildPreferredOutreachFromApi = (outreachWindows = []) => {
    const predefined = [...PREFERRED_OUTREACH_OPTIONS];
    const options = [...predefined];
    const selected = [];

    const formatLabel = (w) => {
        const start = dayjs(`1970-01-01 ${w.startTime}`);
        const end = dayjs(`1970-01-01 ${w.endTime}`);
        return `${start.format('h:mm a')} - ${end.format('h:mm a')} ${w.timezone}`;
    };

    const keyFor = (w) => {
        const m = predefined.find(
            (p) =>
                p.startTime === w.startTime &&
                p.endTime === w.endTime &&
                p.timezone === w.timezone
        );
        if (m) return m.key;
        return w.id != null ? `custom_${w.id}` : `custom_${w.startTime}_${w.endTime}_${w.timezone}`;
    };

    for (const w of outreachWindows) {
        const k = keyFor(w);
        const isPredefinedKey = predefined.some((p) => p.key === k);
        if (!isPredefinedKey) {
            const exists = options.some((o) => o.key === k);
            if (!exists) {
                options.push({
                    key: k,
                    label: formatLabel(w),
                    isCustome: true,
                    startTime: w.startTime,
                    endTime: w.endTime,
                    timezone: w.timezone,
                });
            }
        }
        if (w.isActive) {
            selected.push({
                key: k,
                startTime: w.startTime,
                endTime: w.endTime,
                timezone: w.timezone,
                isCustom: !!w.isCustom,
            });
        }
    }

    return { options, selected };
};

const mapCampaignDetailToFormValues = (c, outreach) => {
    const tz = c.startTimezone || c.endTimezone || 'PST';
    return {
        campaignName: c.campaignName || '',
        clientName: c.clientName || '',
        groupCode: c.groupCode || '',
        product: c.productId != null ? String(c.productId) : undefined,
        coverageStartDate: c.coverageStartDate ? dayjs(c.coverageStartDate) : null,
        campaignStartDate: c.campaignStartDate ? dayjs(c.campaignStartDate) : null,
        campaignStartTime: parseTimeToDayjs(c.campaignStartTime),
        campaignTimeZone: tz,
        campaignEndDate: c.campaignEndDate ? dayjs(c.campaignEndDate) : null,
        campaignEndTime: parseTimeToDayjs(c.campaignEndTime),
        blackoutDates: [...(c.blackoutDates || [])],
        preferredOutreachTimes: outreach.selected,
    };
};

const csvSampleInfoContent = "Upload a CSV file with member details like Name, Phone Number, Email, and Address.Download the sample template to ensure correct format.";

const downloadBase64CsvFile = (base64String, fileName = 'sample-csv-template.csv') => {
    if (!base64String) return false;
    const sanitizedBase64 = String(base64String).includes(',')
        ? String(base64String).split(',').pop()
        : String(base64String);
    const byteCharacters = atob(sanitizedBase64);
    const byteNumbers = new Array(byteCharacters.length);
    for (let i = 0; i < byteCharacters.length; i += 1) {
        byteNumbers[i] = byteCharacters.charCodeAt(i);
    }
    const byteArray = new Uint8Array(byteNumbers);
    const blob = new Blob([byteArray], { type: 'text/csv;charset=utf-8;' });
    const objectUrl = URL.createObjectURL(blob);
    const link = document.createElement('a');
    link.href = objectUrl;
    link.download = fileName;
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
    URL.revokeObjectURL(objectUrl);
    return true;
};


const CampaignDetails = () => {
    const navigate = useNavigate();
    const location = useLocation();
    const dispatch = useDispatch();
    const { brandId } = useContext(ThemeContext);
    const { campaignId: editCampaignId, refBrandId: editRefBrandId, mode: routeMode } = location.state || {};
    const isEditMode = routeMode === 'edit' && editCampaignId != null && editRefBrandId != null;

    const { isLoading, data: campaignResponse, message: successMessage, error } = useSelector((state) => state.createAiCampaign);
    const { isLoading: updateLoading, message: updateMessage, error: updateError, data: updateData } = useSelector((state) => state.updateAiCampaign);
    const campaignDetailsState = useSelector((state) => state.getAiCampaignDetails);
    const productListState = useSelector((state) => state.productListDropdown);
    const downloadSampleCsvState = useSelector((state) => state.downloadAiCampaignSampleCsv);
    const [productOptions, setProductOptions] = useState([]);
    const [productPage, setProductPage] = useState(1);
    const [hasMoreProducts, setHasMoreProducts] = useState(true);
    const [productSearchText, setProductSearchText] = useState("");

    // UI state that doesn't belong in Formik data payload
    const [productOpen, setProductOpen] = useState(false);
    const [startTimeOpen, setStartTimeOpen] = useState(false);
    const [endTimeOpen, setEndTimeOpen] = useState(false);
    const [preferredOutreachOptions, setPreferredOutreachOptions] = useState(() => [...PREFERRED_OUTREACH_OPTIONS]);
    const [customStartTime, setCustomStartTime] = useState(null);
    const [customEndTime, setCustomEndTime] = useState(null);
    const [customTimeZoneValue, setCustomTimeZoneValue] = useState('PST');
    const [customTimeZoneOpen, setCustomTimeZoneOpen] = useState(false);
    const [csvUploadData, setCsvUploadData] = useState(null);
    const [editCsvFileName, setEditCsvFileName] = useState('');
    const [csvOriginalFileName, setCsvOriginalFileName] = useState('');
    const [csvRemoved, setCsvRemoved] = useState(false);
    const [showUploadIssueModal, setShowUploadIssueModal] = useState(false);
    const [uploadIssueReportUrl, setUploadIssueReportUrl] = useState("");
    const [infoPopoverVisible, setInfoPopoverVisible] = useState(false);

    const todayStart = useMemo(() => dayjs().startOf('day'), []);

    const defaultInitialValues = useMemo(() => ({
        campaignName: '',
        clientName: '',
        groupCode: '',
        product: undefined,
        coverageStartDate: null,
        campaignStartDate: null,
        campaignStartTime: null,
        campaignTimeZone: 'PST',
        campaignEndDate: null,
        campaignEndTime: null,
        blackoutDates: [],
        preferredOutreachTimes: [
           
        ],
    }), []);

    const [prefilledValues, setPrefilledValues] = useState(null);

    const campaignDetail = campaignDetailsState?.data?.data ?? campaignDetailsState?.data;
    const isCampaignActive =
        isEditMode && String(campaignDetail?.status ?? '').toLowerCase() === 'active';

    const fetchProducts = useCallback((page = 1, searchText) => {
        const refId = brandId ?? editRefBrandId;
        if (refId) {
            const trimmedSearchText = typeof searchText === 'string' ? searchText.trim() : undefined;
            dispatch(
                productListDropdownHandler({
                    offSet: page,
                    limit: PRODUCT_PAGE_SIZE,
                    refBrandId: refId,
                    // Backend naming differs across endpoints; send both keys.
                    ...(trimmedSearchText
                        ? { search: trimmedSearchText, searchString: trimmedSearchText }
                        : {}),
                }),
            );
        }
    }, [dispatch, brandId, editRefBrandId]);

    useEffect(() => {
        if (!isEditMode) {
            dispatch(getAiCampaignDetailsAction.getAiCampaignDetailsInfoReset());
            setPrefilledValues(null);
            setPreferredOutreachOptions([...PREFERRED_OUTREACH_OPTIONS]);
        }
    }, [dispatch, isEditMode]);

    useEffect(() => {
        if (!isEditMode || !editCampaignId || !editRefBrandId) return;
        dispatch(getAiCampaignDetailsAction.getAiCampaignDetailsInfoReset());
        dispatch(getAiCampaignDetailsHandler({ campaignId: editCampaignId, refBrandId: editRefBrandId }));
    }, [dispatch, isEditMode, editCampaignId, editRefBrandId]);

    useEffect(() => {
        if (!isEditMode || !campaignDetail?.id || campaignDetail.id !== editCampaignId) return;
        const outreach = buildPreferredOutreachFromApi(campaignDetail.outreachWindows || []);
        setPreferredOutreachOptions(outreach.options);
        setPrefilledValues(mapCampaignDetailToFormValues(campaignDetail, outreach));
        setEditCsvFileName(campaignDetail?.csvFileName || '');
        setCsvOriginalFileName(campaignDetail?.csvFileName || '');
        setCsvRemoved(false);
    }, [isEditMode, campaignDetail, editCampaignId]);

    useEffect(() => {
        if (!isEditMode || !campaignDetail?.productId || campaignDetail.id !== editCampaignId) return;
        const pid = String(campaignDetail.productId);
        const pname = campaignDetail.productName;
        setProductOptions((prev) => {
            if (prev.some((o) => o.value === pid)) return prev;
            return [{ value: pid, label: pname }, ...prev];
        });
    }, [isEditMode, campaignDetail?.id, campaignDetail?.productId, campaignDetail?.productName, editCampaignId]);

    useEffect(() => {
        setProductOptions([]);
        setProductPage(1);
        setHasMoreProducts(true);
        setProductSearchText("");
        fetchProducts(1);
    }, [brandId, editRefBrandId, fetchProducts]);

    useEffect(() => {
        const responseData = productListState?.data;
        if (!responseData) return;
        const items = (responseData.data || []).map(({ id, name, code }) => ({
            value: String(id),
            label: name + " - " + code,
        }));
        setProductOptions((prev) => {
            const existingKeys = new Set(prev.map((o) => o.value));
            const newItems = items.filter((o) => !existingKeys.has(o.value));
            return productPage === 1 ? items : [...prev, ...newItems];
        });
        const { totalElements, pageNumber = 1, pageSize = PRODUCT_PAGE_SIZE } = responseData;
        const itemCount = items.length;
        if (typeof totalElements === 'number' && totalElements > 0) {
            setHasMoreProducts(pageNumber * pageSize < totalElements);
        } else {
            setHasMoreProducts(itemCount >= PRODUCT_PAGE_SIZE);
        }
    }, [productListState?.data, productPage]);

    const handleProductScroll = useCallback((e) => {
        const { scrollTop, scrollHeight, clientHeight } = e.target;
        if (scrollTop + clientHeight >= scrollHeight - 10 && hasMoreProducts && !productListState?.isLoading) {
            const nextPage = productPage + 1;
            setProductPage(nextPage);
            fetchProducts(nextPage, productSearchText);
        }
    }, [hasMoreProducts, productListState?.isLoading, productPage, fetchProducts, productSearchText]);

    const handleProductSearch = useCallback((nextSearchText) => {
        const trimmedVal = String(nextSearchText ?? "").trim();
        setProductSearchText(trimmedVal);

        // Reset the list so results don't mix between different queries
        setProductOptions([]);
        setProductPage(1);
        setHasMoreProducts(true);

        // If cleared, immediately load the default page.
        if (!trimmedVal) {
            fetchProducts(1, undefined);
        }
    }, [fetchProducts]);

    useEffect(() => {
        if (!productSearchText) return;

        const t = setTimeout(() => {
            fetchProducts(1, productSearchText);
        }, 500);

        return () => clearTimeout(t);
    }, [productSearchText, fetchProducts]);

    // Setup Formik
    const formik = useFormik({
        initialValues: prefilledValues ?? defaultInitialValues,
        enableReinitialize: true,
        validationSchema: Yup.object({
            campaignName: Yup.string()
                .trim()
                .required('Campaign Name is required.')
                .max(100, 'Campaign Name must not exceed 100 characters.'),
            clientName: Yup.string()
                .trim()
                .required('Client Name is required.'),
            groupCode: Yup.string()
                .required('Group Code is required.')
                .matches(/^[A-Za-z0-9-]{1,20}$/, 'Group Code format is invalid.'),
            product: Yup.string().required('Product selection is required.'),
            coverageStartDate: Yup.date()
                .nullable()
                .required('Coverage Start Date is required')
                .test(
                    'max-campaign-end',
                    'Coverage Start Date must be on or before Campaign End Date',
                    function coverageBeforeEnd(coverageStart) {
                        const { campaignEndDate: end } = this.parent;
                        if (!coverageStart || !end) return true;
                        return !dayjs(coverageStart).startOf('day').isAfter(dayjs(end).startOf('day'));
                    },
                ),
            campaignStartDate: Yup.date().nullable().required('Campaign Start Date is required.'),
            campaignStartTime: Yup.date().nullable().required('Campaign Start Time is required.'),
            campaignEndDate: Yup.date()
                .nullable()
                .required('Campaign End Date is required.')
                .test(
                    'after-start-day',
                    'Campaign End Date must be at least one day after the Campaign Start Date.',
                    function campaignEndAfterStartDay(endDate) {
                        const { campaignStartDate: start } = this.parent;
                        if (!endDate || !start) return true;
                        return dayjs(endDate).startOf('day').isAfter(dayjs(start).startOf('day'));
                    },
                ),
            campaignEndTime: Yup.date().nullable().required('Campaign End Time is required.'),
            blackoutDates: Yup.array().test(
                'at-least-one-active-day',
                'At least one non-blackout day must exist within the campaign window.',
                function validateBlackoutDates(blackoutDates) {
                    const { campaignStartDate, campaignEndDate } = this.parent;
                    if (!campaignStartDate || !campaignEndDate) return true;
                    const start = dayjs(campaignStartDate).startOf('day');
                    const end = dayjs(campaignEndDate).startOf('day');
                    if (!start.isValid() || !end.isValid() || end.isBefore(start)) return true;

                    const totalDays = end.diff(start, 'day') + 1;
                    const selectedDays = Array.isArray(blackoutDates) ? blackoutDates.length : 0;
                    return selectedDays < totalDays;
                },
            ),
            preferredOutreachTimes: Yup.array()
                .min(1, 'At least one preferred outreach time window is required.')
                .required('At least one preferred outreach time window is required.'),
        }).test(
            'campaign-min-duration-24h',
            function campaignMin24h(values) {
                const start = combineCampaignDateTime(values.campaignStartDate, values.campaignStartTime);
                const end = combineCampaignDateTime(values.campaignEndDate, values.campaignEndTime);
                if (!start || !end || !start.isValid() || !end.isValid()) return true;
                if (end.diff(start, 'minute') < 24 * 60) {
                    return this.createError({
                        path: 'campaignEndTime',
                        message: 'Campaign must span at least 24 hours — adjust end date and/or end time',
                    });
                }
                return true;
            },
        ).test(
            'csv-file-required',
            function csvFileRequired() {
                const hasCsvFile = !!(
                    csvUploadData?.signedUrl ||
                    (isEditMode ? (editCsvFileName && !csvRemoved) : false)
                );
                if (hasCsvFile) return true;
                return this.createError({
                    path: 'csvFile',
                    message: 'Census file is required to launch an Enrollment Campaign.',
                });
            },
        ),
        onSubmit: (values) => {
            const mappedOutreachWindows = preferredOutreachOptions.map(opt => {
                const isActive = values.preferredOutreachTimes.some(item => item.key === opt.key);
                return {
                    startTime: opt.startTime,
                    endTime: opt.endTime,
                    timezone: opt.timezone,
                    isCustom: !!opt.isCustome,
                    isActive: isActive
                };
            });

            const payload = {
                campaignName: values.campaignName,
                campaignType: "ENROLLMENT",
                clientName: values.clientName,
                groupCode: values.groupCode,
                productId: values.product ? Number(values.product) : 1,
                coverageStartDate: values.coverageStartDate ? dayjs(values.coverageStartDate).format('YYYY-MM-DD') : null,
                campaignStartDate: values.campaignStartDate ? dayjs(values.campaignStartDate).format('YYYY-MM-DD') : null,
                campaignStartTime: values.campaignStartTime ? dayjs(values.campaignStartTime).format('HH:mm:ss') : null,
                startTimezone: values.campaignTimeZone,
                campaignEndDate: values.campaignEndDate ? dayjs(values.campaignEndDate).format('YYYY-MM-DD') : null,
                campaignEndTime: values.campaignEndTime ? dayjs(values.campaignEndTime).format('HH:mm:ss') : null,
                endTimezone: values.campaignTimeZone,
                refBrandId: isEditMode ? editRefBrandId : (brandId),
                blackoutDates: values.blackoutDates,
                outreachWindows: mappedOutreachWindows
            };

            const payloadCsvFileName = csvUploadData?.signedUrl
                ? csvOriginalFileName
                : ((isEditMode && !csvRemoved) ? editCsvFileName : '');
            if (payloadCsvFileName) {
                payload.csvFileName = payloadCsvFileName;
            }

            if (csvUploadData?.signedUrl) {
                payload.csvFileUrl = csvUploadData.signedUrl;
            } else if (isEditMode && csvRemoved) {
                payload.csvFileUrl = "";
                payload.csvFileName = "";
            }

            if (isEditMode) {
                dispatch(updateAiCampaignHandler({ id: editCampaignId, ...payload }));
            } else {
                dispatch(createAiCampaignHandler(payload));
            }
        },
    });

    const { values, setFieldValue, setFieldTouched, handleChange, handleBlur, handleSubmit, errors, touched, submitCount } = formik;

    const handleCampaignStartDateChange = (value) => {
        setFieldValue('campaignStartDate', value, true);
        if (!value || !values.campaignEndDate) return;
        const startDay = value.startOf('day');
        const endDay = values.campaignEndDate.startOf('day');
        // End must be a different calendar day and strictly after start
        if (!endDay.isAfter(startDay)) {
            setFieldValue('campaignEndDate', value.add(1, 'day'), true);
        }
    };

    const handleCampaignEndDateChange = (value) => {
        if (!value) {
            setFieldValue('campaignEndDate', value, true);
            return;
        }
        let finalEnd = value;
        if (values.campaignStartDate) {
            const startDay = values.campaignStartDate.startOf('day');
            const pickDay = value.startOf('day');
            if (!pickDay.isAfter(startDay)) {
                finalEnd = values.campaignStartDate.add(1, 'day');
            }
        }
        setFieldValue('campaignEndDate', finalEnd, true);
        if (
            values.coverageStartDate &&
            finalEnd &&
            values.coverageStartDate.startOf('day').isAfter(finalEnd.startOf('day'))
        ) {
            setFieldValue('coverageStartDate', finalEnd);
        }
    };

    const disablePastDates = (current) => !!current && dayjs(current).startOf('day').isBefore(todayStart);

    const disableCampaignEndDates = (current) => {
        if (!current) return false;
        const currentDay = dayjs(current).startOf('day');
        if (currentDay.isBefore(todayStart)) return true;
        if (!values.campaignStartDate) return false;
        const startDay = values.campaignStartDate.startOf('day');
        // Same calendar day as start (or earlier) is not allowed — require next day or later
        return !currentDay.isAfter(startDay);
    };

    const disableCoverageDatesAfterCampaignEnd = (current) => {
        if (!current || !values.campaignEndDate) return false;
        return dayjs(current).startOf('day').isAfter(values.campaignEndDate.startOf('day'));
    };

    const handleCsvFileSelected = async (file) => {
        const fileName = String(file?.name || '').toLowerCase();
        if (!fileName.endsWith('.csv')) {
            message.error('Only CSV files are accepted. Please upload a .csv file.');
            return false;
        }
        if (Number(file?.size || 0) / 1024 / 1024 > 10) {
            message.error('File size exceeds the maximum allowed limit.');
            return false;
        }

        const adminId = getItem("adminId");
        const originalName = String(file?.name || "census.csv");
        const lastDotIndex = originalName.lastIndexOf(".");
        const baseName = lastDotIndex > -1 ? originalName.slice(0, lastDotIndex) : originalName;
        const extension = lastDotIndex > -1 ? originalName.slice(lastDotIndex) : ".csv";
        const timestampedFile = new File(
            [file],
            `${baseName}_${dayjs().format("YYYYMMDDHHmmss")}${extension}`,
            { type: file?.type || "text/csv" },
        );
        const formData = new FormData();
        formData.append("file", timestampedFile);
        formData.append("id", Number(adminId));
        formData.append("brandId", brandId ?? editRefBrandId);
        formData.append("path", "campaign/census");

        try {
            const response = await axios.post(`${API_URL}/file/upload`, formData, {
                headers: {
                    "Content-Type": "multipart/form-data",
                    Authorization: `Bearer ${localStorage.getItem("token")}`,
                },
            });
            setCsvUploadData(response?.data?.data || response?.data || null);
            setCsvOriginalFileName(originalName);
            setCsvRemoved(false);
            // message.success(response?.data?.message || "CSV uploaded successfully");
            return true;
        } catch (uploadError) {
            const uploadErrorMessage = uploadError?.response?.data?.message || "CSV upload failed";
            message.error(uploadErrorMessage);
            return false;
        }
    };

    const handleDownloadUploadIssueReport = () => {
        if (!uploadIssueReportUrl) {
            message.error("Report file is not available");
            return;
        }

        const link = document.createElement("a");
        link.href = uploadIssueReportUrl;
        link.target = "_blank";
        link.rel = "noopener noreferrer";
        link.download = "upload-error-report.csv";
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
        if (isEditMode) {
            dispatch(updateAiCampaignAction.updateAiCampaignInfoReset());
        } else {
            dispatch(createAiCampaignAction.createAiCampaignInfoReset());
        }
    };

    const handleAddCustomTimeWindow = () => {
        if (!customStartTime) {
            message.error('Start Time is required for the custom time window.');
            return;
        }
        if (!customEndTime) {
            message.error('End Time is required for the custom time window.');
            return;
        }
        const start = dayjs(customStartTime);
        const end = dayjs(customEndTime);
        if (!start.isValid() || !end.isValid()) {
            message.error('Invalid start or end time.');
            return;
        }
        if (!end.isAfter(start)) {
            message.error('End Time must be after Start Time.');
            return;
        }

        const key = `custom_${start.format('HHmm')}-${end.format('HHmm')}_${customTimeZoneValue}`;
        const label = `${start.format('h:mm a')} - ${end.format('h:mm a')} ${customTimeZoneValue}`;
        const newStartMinutes = start.hour() * 60 + start.minute();
        const newEndMinutes = end.hour() * 60 + end.minute();
        const hasOverlap = preferredOutreachOptions.some((o) => {
            if (o.timezone !== customTimeZoneValue) return false;
            const existingStart = dayjs(`1970-01-01 ${o.startTime}`);
            const existingEnd = dayjs(`1970-01-01 ${o.endTime}`);
            if (!existingStart.isValid() || !existingEnd.isValid()) return false;
            const existingStartMinutes = existingStart.hour() * 60 + existingStart.minute();
            const existingEndMinutes = existingEnd.hour() * 60 + existingEnd.minute();
            return newStartMinutes < existingEndMinutes && newEndMinutes > existingStartMinutes;
        });
        if (hasOverlap) {
            message.error('This time window overlaps with an existing window.');
            return;
        }

        const newOpt = {
            key,
            label,
            isCustome: true,
            startTime: start.format('HH:mm:ss'),
            endTime: end.format('HH:mm:ss'),
            timezone: customTimeZoneValue
        };

        setPreferredOutreachOptions((prev) => {
            if (prev.some((o) => o.key === key)) return prev;
            return [...prev, newOpt];
        });

        const newPrefs = [...values.preferredOutreachTimes];
        if (!newPrefs.some(item => item.key === key)) {
            newPrefs.push({
                key: newOpt.key,
                startTime: newOpt.startTime,
                endTime: newOpt.endTime,
                timezone: newOpt.timezone,
                isCustom: true
            });
            setFieldValue('preferredOutreachTimes', newPrefs);
            setFieldTouched('preferredOutreachTimes', true);
        }

        setCustomStartTime(null);
        setCustomEndTime(null);
    };

    const handleDeletePreferredOutreachOption = (key) => {
        setPreferredOutreachOptions((prev) => prev.filter((o) => o.key !== key));
        const newPrefs = values.preferredOutreachTimes.filter(item => item.key !== key);
        setFieldValue('preferredOutreachTimes', newPrefs);
        setFieldTouched('preferredOutreachTimes', true);
    };

    useEffect(() => {
        if (!values.campaignStartDate || !values.campaignEndDate) {
            setFieldValue('blackoutDates', []);
            return;
        }
        const start = values.campaignStartDate.startOf('day');
        const end = values.campaignEndDate.startOf('day');
        if (start.isAfter(end)) {
            setFieldValue('blackoutDates', []);
            return;
        }
        const rangeStart = start;
        const rangeEnd = end;

        const validDates = values.blackoutDates.filter((dateStr) => {
            const d = dayjs(dateStr).startOf('day');
            return (d.isAfter(rangeStart) || d.isSame(rangeStart)) && (d.isBefore(rangeEnd) || d.isSame(rangeEnd));
        });

        // Use JSON.stringify check to avoid infinite loops when calling setFieldValue in useEffect
        if (JSON.stringify(validDates) !== JSON.stringify(values.blackoutDates)) {
            setFieldValue('blackoutDates', validDates);
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [values.campaignStartDate, values.campaignEndDate]);

    useEffect(() => {
        if (campaignResponse?.statusCode === 409) {

            setUploadIssueReportUrl(campaignResponse?.data?.errorFileUrl);
            setShowUploadIssueModal(true);
            return

        }
        if (successMessage && campaignResponse) {
            message.success(successMessage);
            dispatch(createAiCampaignAction.createAiCampaignInfoReset());
            navigate('/ai-campaigns/campaign-list');
        }
        if (error) {
            message.error(error);
            dispatch(createAiCampaignAction.createAiCampaignInfoReset());
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [successMessage, error, campaignResponse]);

    useEffect(() => {
        if (updateData?.statusCode === 409) {

            setUploadIssueReportUrl(updateData?.data?.errorFileUrl);
            setShowUploadIssueModal(true);
            return

        }
        if (!updateMessage || !updateData) return;
        message.success(updateMessage);
        dispatch(updateAiCampaignAction.updateAiCampaignInfoReset());
        navigate('/ai-campaigns/manage-ai-campaign', {
            state: { campaignId: editCampaignId, refBrandId: editRefBrandId },
        });
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [updateMessage, updateData]);

    useEffect(() => {
        if (!updateError) return;
        message.error(updateError);
        dispatch(updateAiCampaignAction.updateAiCampaignInfoReset());
    }, [updateError, dispatch]);

    useEffect(() => {
        if (!isEditMode || !campaignDetailsState?.error) return;
        message.error(campaignDetailsState.error);
    }, [isEditMode, campaignDetailsState?.error]);

    useEffect(() => {
        if (downloadSampleCsvState?.error) {
            message.error(downloadSampleCsvState.error);
            dispatch(downloadAiCampaignSampleCsvAction.downloadAiCampaignSampleCsvInfoReset());
            return;
        }
        const base64Csv = downloadSampleCsvState?.data?.data;
        if (!base64Csv) return;

        try {
            const isDownloaded = downloadBase64CsvFile(base64Csv, 'sample-csv-template.csv');
            if (!isDownloaded) {
                message.error('Unable to download sample CSV file.');
            }
        } catch (downloadError) {
            message.error('Unable to download sample CSV file.');
        } finally {
            dispatch(downloadAiCampaignSampleCsvAction.downloadAiCampaignSampleCsvInfoReset());
        }
    }, [downloadSampleCsvState?.data, downloadSampleCsvState?.error, dispatch]);

    const showEditLoader =
        isEditMode &&
        (campaignDetailsState?.isLoading ||
            (!prefilledValues && !campaignDetailsState?.error));

    const handleSelectSlot = (slotInfo) => {
        if (!values.campaignStartDate || !values.campaignEndDate) return;
        const slots = slotInfo?.slots || (slotInfo?.start ? [slotInfo.start] : []);
        if (!slots.length) return;
        const start = values.campaignStartDate.startOf('day');
        const end = values.campaignEndDate.startOf('day');
        if (start.isAfter(end)) return;
        const rangeStart = start;
        const rangeEnd = end;
        const dateStrs = slots
            .map((d) => dayjs(d).startOf('day'))
            .filter((d) => !d.isBefore(todayStart))
            .filter((d) => (d.isAfter(rangeStart) || d.isSame(rangeStart)) && (d.isBefore(rangeEnd) || d.isSame(rangeEnd)))
            .map((d) => d.format('YYYY-MM-DD'));
        if (!dateStrs.length) return;

        const newSet = new Set(values.blackoutDates);
        dateStrs.forEach((dateStr) => {
            if (newSet.has(dateStr)) newSet.delete(dateStr);
            else newSet.add(dateStr);
        });
        setFieldValue('blackoutDates', [...newSet].sort());
    };

    const dayPropGetter = useMemo(() => (date) => {
        const d = dayjs(date).startOf('day');
        const dateStr = d.format('YYYY-MM-DD');
        if (values.blackoutDates.includes(dateStr)) {
            return { className: 'blackout-day' };
        }
        if (!values.campaignStartDate || !values.campaignEndDate) return {};
        const start = values.campaignStartDate.startOf('day');
        const end = values.campaignEndDate.startOf('day');
        if (start.isAfter(end)) return {};
        const rangeStart = start;
        const rangeEnd = end;
        if ((d.isAfter(rangeStart) || d.isSame(rangeStart)) && (d.isBefore(rangeEnd) || d.isSame(rangeEnd))) {
            const classes = ['campaign-range-day'];
            if (d.isSame(rangeStart)) classes.push('campaign-start-day');
            if (d.isSame(rangeEnd)) classes.push('campaign-end-day');
            return { className: classes.join(' ') };
        }
        return {};
    }, [values.campaignStartDate, values.campaignEndDate, values.blackoutDates]);

    if (showEditLoader) {
        return <Loader loaderTransform="loaderTransform" />;
    }

    const saving = isLoading || updateLoading;

    const handleDownloadSampleCsv = () => {
        if (downloadSampleCsvState?.isLoading) return;
        dispatch(downloadAiCampaignSampleCsvHandler());
    };

    return (
        <div className="rightside">
            <div className="rightcontent">
                <p>
                    <strong>Create Enrollment Campaign</strong>
                </p>
                <CustomBreadcrumb
                    items={[
                        { text: BreadCrum.HOME },
                        { text: "AI Campaigns" },
                        {
                            text: "Campaign List",
                            onClick: () => navigate("/ai-campaigns/campaign-list"),
                            active: true,
                        },
                        {
                            text: isEditMode ? "Edit Enrollment Campaign" : "Create Enrollment Campaign",
                            active: true,
                        }
                    ]}
                />

                <form onSubmit={handleSubmit}>
                    <div className="usercard mb-30">
                        <div className="campaignDetailsCard">
                            <span className="campaigncardHeader">
                                Campaign Information*
                            </span>
                        </div>
                        <hr className="m-0" />
                        <div className="campaigncardBody login-form">
                            <div className="form-group">
                                <label htmlFor="campaignName">Campaign Name</label>
                                <input
                                    type="text"
                                    className="form-control p-16 "
                                    id="campaignName"
                                    name="campaignName"
                                    placeholder="Enter Campaign Name"
                                    value={values.campaignName}
                                    onChange={handleChange}
                                    onBlur={handleBlur}
                                />
                                {touched.campaignName && errors.campaignName && (
                                    <div className="text-danger small mt-1" style={{ color: 'red' }}>{errors.campaignName}</div>
                                )}
                            </div>
                            <div className="form-group">
                                <label htmlFor="clientName">Client Name</label>
                                <input
                                    type="text"
                                    className="form-control p-16"
                                    id="clientName"
                                    name="clientName"
                                    placeholder="Enter Client Name"
                                    value={values.clientName}
                                    onChange={handleChange}
                                    onBlur={handleBlur}
                                />
                                {touched.clientName && errors.clientName && (
                                    <div className="text-danger small mt-1" style={{ color: 'red' }}>{errors.clientName}</div>
                                )}
                            </div>
                            <div className="form-group">
                                <label htmlFor="groupCode">Group Code</label>
                                <input
                                    type="text"
                                    className="form-control"
                                    id="groupCode"
                                    name="groupCode"
                                    placeholder="Enter Group Code"
                                    value={values.groupCode}
                                    onChange={handleChange}
                                    onBlur={handleBlur}
                                />
                                {touched.groupCode && errors.groupCode && (
                                    <div className="text-danger small mt-1" style={{ color: 'red' }}>{errors.groupCode}</div>
                                )}
                            </div>
                            <div className="form-group customSelectInput">
                                <label htmlFor="product">Product</label>
                                <Select
                                    id="product"
                                    className="customSelect w-100"
                                    placeholder="Select Product from PCGS Products"
                                    value={values.product}
                                    onChange={(value) => setFieldValue('product', value)}
                                    onBlur={() => formik.setFieldTouched('product', true)}
                                    onOpenChange={setProductOpen}
                                    showSearch
                                    filterOption={false}
                                    onSearch={handleProductSearch}
                                    suffixIcon={<ChevronIcon isOpen={productOpen} />}
                                    options={productOptions}
                                    loading={productListState?.isLoading}
                                    onPopupScroll={handleProductScroll}
                                    notFoundContent={productListState?.isLoading ? <Spin size="small" /> : 'No products found'}
                                    optionFilterProp="label"
                                />
                                {touched.product && errors.product && (
                                    <div className="text-danger small mt-1" style={{ color: 'red' }}>{errors.product}</div>
                                )}
                            </div>
                            <div className="form-group noicon visibleicon">
                                <label htmlFor="coverageStartDate">Coverage Start Date</label>
                                <DatePicker
                                    id="coverageStartDate"
                                    className="w-100 customDatePicker"
                                    placeholder="MM / DD / YYYY"
                                    format="MM / DD / YYYY"
                                    value={values.coverageStartDate}
                                    onChange={(date) => setFieldValue('coverageStartDate', date)}
                                    onBlur={() => formik.setFieldTouched('coverageStartDate', true)}
                                    disabledDate={disableCoverageDatesAfterCampaignEnd}
                                    suffixIcon={<CalanderIcon />}
                                // disabled={isCampaignActive}
                                />
                                {touched.coverageStartDate && errors.coverageStartDate && (
                                    <div className="text-danger small mt-1" style={{ color: 'red' }}>{errors.coverageStartDate}</div>
                                )}
                            </div>
                        </div>
                    </div>

                    <div className="usercard mb-30">
                        <div className="campaignDetailsCard d-flex flex-column">
                            <span className="campaigncardHeader mb-10">
                                Campaign Information*
                            </span>
                            <p className="mb-0">AI Agent will contact perspective members with in the date range</p>
                        </div>
                        <hr className="m-0" />
                        <div className="campaigncardBody login-form">
                            <div className="form-group noicon visibleicon">
                                <label htmlFor="campaignStartDate">Campaign Start Date</label>
                                <DatePicker
                                    id="campaignStartDate"
                                    className="w-100 customDatePicker"
                                     placeholder="MM / DD / YYYY"
                                    format="MM / DD / YYYY"
                                    value={values.campaignStartDate}
                                    onChange={handleCampaignStartDateChange}
                                    onBlur={() => formik.setFieldTouched('campaignStartDate', true)}
                                    disabledDate={disablePastDates}
                                    suffixIcon={<CalanderIcon />}
                                    disabled={isCampaignActive}
                                />
                                {touched.campaignStartDate && errors.campaignStartDate && (
                                    <div className="text-danger small mt-1" style={{ color: 'red' }}>{errors.campaignStartDate}</div>
                                )}
                            </div>
                            <div className="form-group noicon visibleicon">
                                <label htmlFor="campaignStartTime">Campaign Start Time</label>
                                <div className="d-flex align-items-center gap-10">
                                    <TimePicker
                                        id="campaignStartTime"
                                        className="w-100 customTimePicker"
                                        placeholder="Select Start Time"
                                        format="HH:mm"
                                        needConfirm={false}
                                        value={values.campaignStartTime}
                                        onChange={(time) => setFieldValue('campaignStartTime', time, true)}
                                        onBlur={() => formik.setFieldTouched('campaignStartTime', true)}
                                        suffixIcon={<TimeIcon />}
                                        disabled={isCampaignActive}
                                    />
                                    <Select
                                        id="campaignStartTimeZone"
                                        name="campaignTimeZone"
                                        className="customSelect w-100 timeZoneSelect"
                                        placeholder="Select Time Zone"
                                        value={values.campaignTimeZone}
                                        onChange={(value) => setFieldValue('campaignTimeZone', value)}
                                        onOpenChange={setStartTimeOpen}
                                        menuItemSelectedIcon={<TimezoneSelectedIcon />}
                                        suffixIcon={<ChevronIcon isOpen={startTimeOpen} />}
                                        options={TIMEZONE_OPTIONS}
                                        disabled={isCampaignActive}
                                    />
                                </div>
                                {touched.campaignStartTime && errors.campaignStartTime && (
                                    <div className="text-danger small mt-1" style={{ color: 'red' }}>{errors.campaignStartTime}</div>
                                )}
                            </div>
                            <div className="form-group noicon visibleicon">
                                <label htmlFor="campaignEndDate">Campaign End Date</label>
                                <DatePicker
                                    id="campaignEndDate"
                                    className="w-100 customDatePicker"
                                     placeholder="MM / DD / YYYY"
                                    format="MM / DD / YYYY"
                                    value={values.campaignEndDate}
                                    onChange={handleCampaignEndDateChange}
                                    onBlur={() => formik.setFieldTouched('campaignEndDate', true)}
                                    disabledDate={disableCampaignEndDates}
                                    suffixIcon={<CalanderIcon />}
                                    disabled={isCampaignActive}
                                />
                                {touched.campaignEndDate && errors.campaignEndDate && (
                                    <div className="text-danger small mt-1" style={{ color: 'red' }}>{errors.campaignEndDate}</div>
                                )}
                            </div>
                            <div className="form-group noicon visibleicon">
                                <label htmlFor="campaignEndTime">Campaign End Time</label>
                                <div className="d-flex align-items-center gap-10">
                                    <TimePicker
                                        id="campaignEndTime"
                                        className="w-100 customTimePicker"
                                        placeholder="Select End Time"
                                        format="HH:mm"
                                        needConfirm={false}
                                        value={values.campaignEndTime}
                                        onChange={(time) => setFieldValue('campaignEndTime', time, true)}
                                        onBlur={() => formik.setFieldTouched('campaignEndTime', true)}
                                        suffixIcon={<TimeIcon />}
                                        disabled={isCampaignActive}
                                    />
                                    <Select
                                        id="campaignEndTimeZone"
                                        name="campaignTimeZone"
                                        className="customSelect w-100 timeZoneSelect"
                                        placeholder="Select Time Zone"
                                        value={values.campaignTimeZone}
                                        onChange={(value) => setFieldValue('campaignTimeZone', value)}
                                        onOpenChange={setEndTimeOpen}
                                        menuItemSelectedIcon={<TimezoneSelectedIcon />}
                                        suffixIcon={<ChevronIcon isOpen={endTimeOpen} />}
                                        options={TIMEZONE_OPTIONS}
                                        disabled={isCampaignActive}
                                    />
                                </div>
                                {touched.campaignEndTime && errors.campaignEndTime && (
                                    <div className="text-danger small mt-1" style={{ color: 'red' }}>{errors.campaignEndTime}</div>
                                )}
                            </div>
                        </div>
                        <hr className="m-0" />

                        {values.campaignStartDate && values.campaignEndDate && (
                            <>
                                <div className="campaignDetailsCard d-flex flex-column">
                                    <p className="mb-0 fs-16 mb-3">Blackout Dates (Optional)</p>
                                    <div className={`blackout-calendar-container blackout-calendar ${values.campaignStartDate && values.campaignEndDate ? 'has-campaign-range' : ''}`}>
                                        <Calendar
                                            localizer={localizer}
                                            events={[]}
                                            defaultView="month"
                                            views={['month']}
                                            selectable={!!(values.campaignStartDate && values.campaignEndDate)}
                                            onSelectSlot={handleSelectSlot}
                                            dayPropGetter={dayPropGetter}
                                            toolbar={true}
                                            style={{ height: 300 }}
                                        />
                                    </div>
                                    {(touched.blackoutDates || submitCount > 0) && errors.blackoutDates && (
                                        <div className="text-danger small mt-2 px-3" style={{ color: 'red' }}>
                                            {errors.blackoutDates}
                                        </div>
                                    )}
                                    <div className="blackout-dates-info">
                                        <InfoIcon />
                                        <p className="mb-2 mt-2 text-muted small">Blue dates = blackout days (no AI Agent contact). Blue = active campaign window. Click any in-range date to toggle blackout.</p>
                                    </div>

                                </div>
                                <hr className="m-0" />
                                {values.blackoutDates.length > 0 && (
                                    <div className="">
                                        <div className="campaignDetailsCard d-flex flex-column blackout-dates-list">
                                            <p className="mb-0 fs-16 ">Blackout Dates (Optional)</p>
                                            <div className="blackout-calendar-arrays">
                                                <div className="blackout-dates-list mb-2 flex-wrap">
                                                    {values.blackoutDates.map((d) => (
                                                        <span key={d} className="dateCard  fs-16 ">{dayjs(d).format("MMMM DD, YYYY")}</span>
                                                    ))}
                                                </div>

                                            </div>
                                        </div>
                                    </div>
                                )}

                            </>
                        )}
                    </div>

                    <div className="usercard mb-30">
                        <div className="campaignDetailsCard d-flex flex-column">
                            <span className="campaigncardHeader mb-10">
                                Preferred Time to Outreach*
                            </span>
                            <p className="mb-0">AI Agent will contact perspective members in the preferred time windows</p>
                        </div>
                        <hr className="m-0" />
                        <div className="campaingcustomTime login-form">
                            <div className='d-flex flex-wrap gap-20 w-100'>
                                {preferredOutreachOptions.map((opt) => {
                                    const id = `preferredOutreachTime_${opt.key}`;
                                    const checked = values.preferredOutreachTimes.some(item => item.key === opt.key);
                                    return (
                                        <label key={opt.key} className="preferredTimeOption" htmlFor={id}>
                                            <input
                                                id={id}
                                                className="preferredTimeOption__input"
                                                type="checkbox"
                                                name="preferredOutreachTimes"
                                                value={opt.key}
                                                checked={checked}
                                                onChange={(e) => {
                                                    let nextList = [...values.preferredOutreachTimes];
                                                    if (e.target.checked) {
                                                        nextList.push({
                                                            key: opt.key,
                                                            startTime: opt.startTime,
                                                            endTime: opt.endTime,
                                                            timezone: opt.timezone,
                                                            isCustom: !!opt.isCustome
                                                        });
                                                    } else {
                                                        nextList = nextList.filter(item => item.key !== opt.key);
                                                    }
                                                    setFieldValue('preferredOutreachTimes', nextList);
                                                    setFieldTouched('preferredOutreachTimes', true);
                                                }}
                                            />
                                            <span className="preferredTimeOption__box" aria-hidden="true" />
                                            <span className="preferredTimeOption__text">{opt.label}</span>
                                            {opt?.isCustome && (
                                                <button
                                                    type="button"
                                                    className="preferredTimeOption__delete d-flex align-items-center"
                                                    onClick={(e) => {
                                                        e.preventDefault();
                                                        e.stopPropagation();
                                                        handleDeletePreferredOutreachOption(opt.key);
                                                    }}
                                                >
                                                    <div className='trashBorder'></div>
                                                    <Trash color={"#CD6422"} />
                                                </button>
                                            )}
                                        </label>
                                    );
                                })}
                            </div>
                            {(touched.preferredOutreachTimes || submitCount > 0) && errors.preferredOutreachTimes && (
                                <div className="text-danger small mt-2" style={{ color: 'red' }}>
                                    {errors.preferredOutreachTimes}
                                </div>
                            )}

                            <div className="d-flex flex-column gap-20">
                                <div className="campaigncardHeader mb-10">
                                    Add Custom Time Window
                                </div>
                                <div className="d-flex gap-20 w-100">
                                    <div className="form-group noicon visibleicon">
                                        <label htmlFor="customStartTime"> Start Time</label>
                                        <div className="d-flex align-items-center gap-10 ">
                                            <TimePicker
                                                id="customStartTime"
                                                className="w-100 customTimePicker"
                                                placeholder="Select Start Time"
                                                format="HH:mm"
                                                value={customStartTime}
                                                onChange={setCustomStartTime}
                                                suffixIcon={<TimeIcon />}
                                                needConfirm={false}
                                            />
                                        </div>
                                    </div>
                                    <div className="form-group noicon visibleicon" >
                                        <label htmlFor="customEndTime">End Time</label>
                                        <div className="d-flex align-items-center gap-10">
                                            <TimePicker
                                                id="customEndTime"
                                                className="w-100 customTimePicker"
                                                placeholder="Select End Time"
                                                format="HH:mm"
                                                value={customEndTime}
                                                onChange={setCustomEndTime}
                                                suffixIcon={<TimeIcon />}
                                                needConfirm={false}
                                            />
                                        </div>
                                    </div>
                                    <div className="form-group noicon visibleicon" style={{
                                        width: "100%",
                                        maxWidth: "120px",
                                    }}>
                                        <label htmlFor="customTimeZone">Time Zone</label>
                                        <div className="d-flex align-items-center gap-10">
                                            <Select
                                                id="customTimeZone"
                                                className="customSelect w-100 timeZoneSelect"
                                                placeholder="Select Time Zone"
                                                value={customTimeZoneValue}
                                                onChange={setCustomTimeZoneValue}
                                                onOpenChange={setCustomTimeZoneOpen}
                                                menuItemSelectedIcon={<TimezoneSelectedIcon />}
                                                suffixIcon={<ChevronIcon isOpen={customTimeZoneOpen} />}
                                                options={TIMEZONE_OPTIONS}
                                            />
                                        </div>
                                    </div>
                                    <div className="d-flex" style={{
                                        alignItems: "end",
                                    }}>
                                        <button type="button" className="primarybtn" onClick={handleAddCustomTimeWindow}>
                                            <div className="plus"></div>
                                            ADD
                                        </button>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>

                    <div className="usercard mb-30">
                        <div className="campaignDetailsCard d-flex justify-content-between align-items-center ">
                            <span className="campaigncardHeader mb-10">
                                CSV Upload - Census*
                            </span>
                            <div className="d-flex align-items-center gap-16">
                                <div
                                    className="campaign-csv-download-btn d-flex align-items-center gap-2 fs-18"
                                    onClick={handleDownloadSampleCsv}
                                >
                                    <ExportResult color={"#162C4E"} />
                                    Download Sample CSV
                                </div>
                                <Popover
                                    content={csvSampleInfoContent}
                                    trigger="click"
                                    open={infoPopoverVisible}
                                    onOpenChange={setInfoPopoverVisible}
                                    overlayClassName="custom-info-popover "
                                    overlayStyle={{ maxWidth: '420px' }}
                                    placement="bottomRight"
                                >
                                    {/* <div className="infoiconpoistion "> */}
                                    <img src={infoicon} alt="Info" style={{ cursor: 'pointer' }} />
                                    {/* </div> */}
                                </Popover>
                            </div>
                        </div>
                        <hr className="m-0" />
                        <div className="campaignDetailsCard display-block">
                            <CsvUploadDragger
                                accept=".csv"
                                maxSizeMB={10}
                                uploadText={(<><u>Click to upload CSV</u> or drag and drop</>)}
                                supportedFormatsText="Supported formats : CSV"
                                infoText="The census data will be used by the AI Agent to identify and contact perspective members. Each member will be assigned a member portal login upon campaign launch."
                                onFileSelected={handleCsvFileSelected}
                                initialFileName={isEditMode ? editCsvFileName : ''}
                                onFileRemoved={() => {
                                    setCsvUploadData(null);
                                    setEditCsvFileName('');
                                    setCsvRemoved(true);
                                }}
                            />
                            {(submitCount > 0) && errors.csvFile && (
                                <div className="text-danger small mt-2" style={{ color: 'red' }}>
                                    {errors.csvFile}
                                </div>
                            )}

                        </div>
                    </div>

                    <div className="text-end mt-30 bgt">
                        <button
                            type="button"
                            className="  py3 fw-18 gbo continuebtn savebtn cancelbtn me-20 transparentbtn"
                            onClick={() =>
                                isEditMode
                                    ? navigate('/ai-campaigns/manage-ai-campaign', {
                                        state: { campaignId: editCampaignId, refBrandId: editRefBrandId },
                                    })
                                    : navigate('/ai-campaigns/campaign-list')
                            }
                        >
                            Cancel
                        </button>
                        <button type="submit" className="okbtn continuebtn" disabled={saving}>
                            {saving
                                ? isEditMode
                                    ? 'Saving...'
                                    : 'Launching...'
                                : isEditMode
                                    ? 'Save Changes'
                                    : 'Launch Campaign'}
                        </button>
                    </div>
                </form>
            </div>
            <CampaignModal
                open={showUploadIssueModal}
                onCancel={() => {
                    setShowUploadIssueModal(false);
                    if (isEditMode) {
                        dispatch(updateAiCampaignAction.updateAiCampaignInfoReset());
                    } else {
                        dispatch(createAiCampaignAction.createAiCampaignInfoReset());
                    }
                }}
                onAction={handleDownloadUploadIssueReport}
                title="Upload Issue Found"
                subtitle="Some user data is missing in the uploaded file."
                actionLabel="Download Report"
                actionIcon={
                    <svg
                        width="18"
                        height="18"
                        viewBox="0 0 24 24"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                    >
                        <path
                            d="M19 9H15V3H9V9H5L12 16L19 9ZM5 18V20H19V18H5Z"
                            fill="#fff"
                        />
                    </svg>
                }
            >
                <div
                    style={{
                        backgroundColor: "#f7f7f8",
                        border: "1px solid #e5e7eb",
                        borderRadius: "10px",
                        padding: "20px 22px",
                    }}
                >
                    <div className="d-flex align-items-center gap-2 mb-2">
                        <InfoIcon />
                        <strong style={{ color: "#162c4e", fontSize: "15px" }}>
                            What you need to do:
                        </strong>
                    </div>
                    <div style={{ color: "#374151", lineHeight: 1.6 }}>
                        {campaignResponse?.message || updateData?.message}
                    </div>
                </div>
            </CampaignModal>
        </div>
    )
}

export default CampaignDetails